<template>
    <div class="box" :style="style" @animationend="animationend"></div>
</template>

<script>
export default {
    props: ['pic', 'frames', 'run', 'time'],
    data() {
        return {
            index: 0,
            framesList: [0],
            timer: null
        };
    },
    computed: {
        style() {
            return {
                backgroundImage: `url(${this.pic})`,
                backgroundPosition: `${this.framesList[this.index]}% 0`
            };
        }
    },
    watch: {
        run(val) {
            val && this.runAnimation();
        }
    },
    methods: {
        animationend(e) {
            this.$emit('animationend', e);
        },
        runAnimation() {
            if (!this.run) {
                return;
            }
            if (this.index + 1 >= this.framesList.length) {
                this.index = 0;
            }
            else {
                this.index = this.index + 1;
            }
            this.timer = setTimeout(() => {
                this.runAnimation();
            }, this.time / (this.frames - 1));
        },
        stopAnimation() {
            clearTimeout(this.timer);
        }
    },
    created() {
        const one = 100 / (this.frames - 1);
        for (let index = 1; index < +this.frames; index++) {
            this.framesList.push(one * index);
        }
        this.run && this.runAnimation();
    }
};
</script>

<style lang="stylus" scoped>
.box
    background-repeat no-repeat
    background-size auto 100%
</style>
